module.exports = __webpack_public_path__ + "img/success.4ca65115.png";